import { CSRF, getData, getElement } from "../../../../helpers";
import { Dt } from "../../../../plugins/datatable";
import { TagModal } from "./modals/store";

class TagsModule extends HTMLElement {
    connectedCallback() {
        this.load();
    }

    load() {
        const DtElement = getElement("[data-table=dt]", this);

        // Start DataTable
        let configDt = {
            processing: true, // Procesar ajax
            serverSide: true, // Mejorar velocidad ajax registros por página
            scrollY: "520px", // Define la altura de desplazamiento para el cuerpo de la tabla
            scrollCollapse: true, // Permite que el contenido colapse dentro del área definida
            fixedHeader: true, // Mantiene el encabezado visible al hacer scroll
        };

        configDt.ajax = {
            url: getData("tagsUrlDt"),
            type: "POST",
            beforeSend: function (request) {
                request.setRequestHeader("X-CSRF-TOKEN", CSRF);
            },
        };

        // Columnas del AJAX
        configDt.columns = [
            { data: "DT_RowIndex", width: "3%", className: "text-center" },
            { data: "name" },
            {
                data: "status",
                width: "5%",
                className: "text-center",
                orderable: false,
            },
            {
                data: "buttons",
                width: "5%",
                className: "text-center",
                orderable: false,
            },
        ];

        const DtCompanies = new Dt(configDt);
        DtCompanies.dataTable(DtElement);
        // End DataTable

        this.addEventListener("click", (e) => {
            const BtnNewTag = e.target.closest("[name=btnNewTag]");
            const BtnEditTag = e.target.closest("[name=btnEditTag]");

            // Agregar Banco
            if (BtnNewTag) {
                TagModal.create(
                    getData(BtnNewTag, "data-bs-target"),
                    getData(BtnNewTag, "title"),
                    getData(BtnNewTag, "data-url")
                );
            }

            // Editar Banco
            if (BtnEditTag) {
                TagModal.edit(
                    getData(BtnEditTag, "data-bs-target"),
                    getData(BtnEditTag, "title"),
                    getData(BtnEditTag, "data-url"),
                    getData(BtnEditTag, "data-data")
                );
            }
        });
    }
}

window.customElements.define("tag-module", TagsModule, {
    extends: "section",
});
